import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

type CustomAlertType = {
    isOpen: boolean,
    onValid: Function,
    onClose: Function,
    title: string,
    content: string
} 

const CustomAlert = (props: CustomAlertType) => {

    const {t} = useTranslation();

    return (
        <Dialog
            open={props.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
            
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{props.content}</DialogContentText>
            </DialogContent>
                
            <DialogActions>
                <Button onClick={() => { props.onClose() }}>{ t('general.cancel') }</Button>
                <Button onClick={() => { props.onValid() }} autoFocus>{ t('general.valid') }</Button>
            </DialogActions>
        </Dialog>
    );
}

export default CustomAlert;